/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect, ReactNode } from 'react';
import Table from '../../../../../components/Table';
import { DeleteIcon, ProductNotFoundChip } from './styles';
import moment from 'moment';
import { Trash2 } from 'styled-icons/feather';
import { SPREADSHEET_PRODUCT_NOT_FOUND } from '../../../../../store/ducks/long-steel-order-item-search/types';

interface ISpreadsheetTableMvpDataSource {
  key: number;
  product: string;
  codProduct: string;
  description: ReactNode;
  quantity: string | number;
  measureUnit: string | ReactNode;
  desiredDate: string | ReactNode;
}

const SpreadsheetTableMvp = ({
  products,
  onRemoveSearchedItem,
  codeIsInternal
}: {
  products: any[];
  onRemoveSearchedItem(productIndex: number): void;
  codeIsInternal: boolean;
}) => {
  const [productsList, setProductsList] = useState<
    ISpreadsheetTableMvpDataSource[]
  >([]);

  const getColumns = () => {
    return [
      {
        title: codeIsInternal
          ? 'Código interno de material'
          : 'Código do material Gerdau',
        dataIndex: 'product'
      },
      {
        title: 'Nº da linha',
        dataIndex: 'codProduct'
      },
      {
        title: 'Produto ',
        dataIndex: 'description'
      },
      {
        title: 'Quantidade',
        dataIndex: 'quantity'
      },
      {
        title: 'Unidade de medida',
        dataIndex: 'measureUnit'
      },
      {
        title: 'Data desejada',
        dataIndex: 'desiredDate'
      },
      {
        title: '',
        dataIndex: 'actions'
      }
    ];
  };

  const ProductNotFound = ({ product }: any) => {
    if (product !== SPREADSHEET_PRODUCT_NOT_FOUND) {
      return product;
    }
    return <ProductNotFoundChip>Produto não identificado</ProductNotFoundChip>;
  };

  const toType = (obj: any): string => {
    return (
      {}.toString
        .call(obj)
        .match(/\s([a-zA-Z]+)/)?.[1]
        .toLowerCase() || ''
    );
  };

  const itemUnavailable = (
    <ProductNotFoundChip>Indisponível</ProductNotFoundChip>
  );

  const measureUnitFormat = (measureUnit: string | ReactNode) => {
    const regex = /[a-zA-Z]/;
    if (typeof measureUnit === 'string' && regex.test(measureUnit)) {
      return measureUnit;
    }
    return itemUnavailable;
  };

  const dateFormat = (date: string | Date | ReactNode) => {
    const dateType = toType(date);
    if (['string', 'date'].includes(dateType)) {
      const today = moment().startOf('day');
      const value = moment(
        dateType === 'date' ? (date as Date) : (date as string)
      );
      if (value.isSameOrBefore(today)) {
        return itemUnavailable;
      }
      if (value.isValid()) {
        return value.format('DD/MM/YYYY');
      }
      return '-';
    }
    return date;
  };

  const errorColor = '#B84232';

  useEffect(() => {
    const data: ISpreadsheetTableMvpDataSource[] = products.map(
      (product: ISpreadsheetTableMvpDataSource, idx: number) => {
        return {
          key: idx,
          product: product.product,
          codProduct: product.codProduct,
          description: <ProductNotFound product={product.description} />,
          quantity: product.quantity,
          measureUnit: measureUnitFormat(product.measureUnit),
          desiredDate: dateFormat(product.desiredDate),
          actions: (
            <DeleteIcon>
              <Trash2
                width={24}
                strokeWidth="2.5px"
                color={errorColor}
                cursor="pointer"
                onClick={() => handleDelete(idx)}
              />
            </DeleteIcon>
          )
        };
      }
    );

    setProductsList(data);
  }, [products]);

  function handleDelete(productIndex: number) {
    onRemoveSearchedItem(productIndex);
  }

  return <Table columns={getColumns()} data={productsList} hasPagination />;
};

export default SpreadsheetTableMvp;
